import { List } from 'immutable';
import { EncoderJob, Actions } from './types';
import getJobParam from './helpers/get-job-param';

export default (state = List([]), { type, data }) => {
  switch (type) {
    case Actions.CREATE:
      return state.push(data);

    case Actions.UPDATE:
      return state.map(job => {
        if (getJobParam(job, data.param.key) === data.param.value) {
          return new EncoderJob({ ...job.toJS(), ...data.data });
        }
        return job;
      });

    case Actions.REMOVE:
      return state.filter(job => {
        return getJobParam(job, data.key) !== data.value;
      });

    default:
      return state;
  }
};
